<div class="row">
  <div class="col-lg-6 col-md-6" *ngFor="let article of blogContent; index as i">
    <app-blog-content-item [blogItem]="article"></app-blog-content-item>
  </div>
  <div class="col-lg-12 col-md-12">
    <div class="pagination-area" *ngIf="!loading && blogContent.length > 0">
      <ul class="pagination justify-content-center">
        <li class="page-item" [ngClass]="{ disabled: blogService.options.page === 1 }">
          <a i18n="@@prevPagePagination" class="page-link" href="javascript:void(0)" (click)="prev()">Previous</a>
        </li>
        <ng-container *ngIf="blogContent">
          <li
            class="page-item"
            *ngFor="let number of numbers"
            [ngClass]="{ active: blogService.options.page === number }"
          >
            <a class="page-link" href="javascript:void(0)" (click)="to(number)">{{ number }}</a>
          </li>
        </ng-container>
        <li class="page-item" [ngClass]="{ disabled: blogService.options.page === numbers.length }">
          <a i18n="@@nextPagePagination" class="page-link" href="javascript:void(0)" (click)="next()" disabled="true"
            >Next</a
          >
        </li>
      </ul>
    </div>
  </div>
</div>
